import type { IAsync, Project } from '../../../../types';

/**
 * Takes a project and determines if there is a last analyzed revision, last resolved revision, or head revision.
 *
 * @param {IAsync<Project>} project - An async-fetched project (ie: { data: project })
 * @returns {string} The revision string.
 */
export default function getLatestRevisionIdFromProject(project: IAsync<Project>): string | null {
  // First we check if there is a last analyzed revision (latest version to be policy scanned)
  if (project.data?.last_analyzed?.loc) {
    return project.data.last_analyzed.loc.revision;
  // Second we check if there is a last resolved revision (latest version to be analyzed by FOSSA)
  }
  if (project.data?.latest?.loc) {
    return project.data.latest.loc.revision;
  }
  if (project.data?.head?.loc) {
    // Since there aren't any revisions that been analyzed or resolved, we default to the head revision (latest version of the branch or tag)
    return project.data.head.loc.revision;
  }
  return null;
}
